import { makeUseAxios } from "axios-hooks";
import cloudURL from "../services/cloud";
import createRequest from "../services/createAxiosRequest";

export const useUsers = makeUseAxios({
  axios: createRequest(`${cloudURL()}/users/`),
});

export const useObjectives = makeUseAxios({
  axios: createRequest(`${cloudURL()}/objectives/`),
});

export const useOneToOnes = makeUseAxios({
  axios: createRequest(`${cloudURL()}/1-2-1/`),
});

export const useComments = makeUseAxios({
  axios: createRequest(`${cloudURL()}/comments/`),
});

export const usePDP = makeUseAxios({
  axios: createRequest(`${cloudURL()}/pdp/`),
});

export const useMyPerformance = makeUseAxios({
  axios: createRequest(`${cloudURL()}/performance-review/`),
});

export const useEvidenceUpload = makeUseAxios({
  axios: createRequest(`${cloudURL()}/evidence`),
});

export const useNotifications = makeUseAxios({
  axios: createRequest(`${cloudURL()}/notifications`),
});

export const usePDF = makeUseAxios({
  axios: createRequest(`${cloudURL()}/pdf`),
});

export const useCentralFunction = makeUseAxios({
  axios: createRequest(`${cloudURL()}/centralFunction`),
});
